import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getNews = async (params) => {
  try {
    const res = await getRequest({ url: "news", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postNews = async (payload) => {
  try {
    const res = await postRequest({ url: "news", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putNews = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "news",
      payload: payload,
      query: { NEWS_ID: id },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
